/**
 * Phase 18 Ask 4.4 — pure helper extracted from BaselineScenarioPicker
 * so its filter logic can be unit-tested without dragging in the
 * API client / axios / localStorage initialisers.
 */
export function isPickable(s) {
    if (s?.is_ephemeral || s?.is_roe_candidate) return false;
    if (s?.is_quick_sim || s?.is_matrix_cell) return false;
    return true;
}
